export default __webpack_public_path__ + "static/media/landing-aid-preview-icon.76e613fb.png";